export default __webpack_public_path__ + "static/media/NLP.9e875d29.jpg";